export default __webpack_public_path__ + "static/media/product-overview-bg.c3667388.webp";